import styled from 'styled-components';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import StableInputMoney from '../StableInputMoney';

export const ContainerTela = styled.div`
  margin-top: 16px;
`;

export const Input = styled(StableInputMoney)`
  font-size: 14px;
  width: 112px;

  ${(props) =>
    props.houveAlteracaoAjCusto &&
    `
  .ant-input {
    border-color: #FABA00 !important;
  }
  `}
`;

export const Total = styled.td`
  padding: 8px !important;
`;

export const Wrapper = styled.div`
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #949494;
  }

  ${(props) =>
    props.disabled &&
    `
    color: #c1c2c4;
    cursor :not-allowed;

    &:hover {
      color: #e0e0e0
    }
  `}
`;

export const Text = styled(CustomText)`
  display: inline-block;
  min-width: 72px;
`;

export const InputNumber = styled(Input)`
  tr > td &.ant-input {
    width: 80px;
  }
`;

export const LinhaColaborador = styled.tr`
  ${(props) =>
    props.semValor ||
    (props.semContrato &&
      `
    & td span.ant-typography, & td input {
      color: #c1c2c4;
    }
  `)}

  ${(props) =>
    props.destaque &&
    `
    & td span.ant-typography, & td input {
      font-weight: bold;
    }
  `}
`;

export const InputProducao = styled.div`
  ${(props) =>
    props.producaoDiferente &&
    `
    & input {
      border-color: black !important;
    }
  `}
`;
